import { render, staticRenderFns } from "./AlternativePage.vue?vue&type=template&id=cfdffcc4&scoped=true&"
import script from "./AlternativePage.vue?vue&type=script&lang=js&"
export * from "./AlternativePage.vue?vue&type=script&lang=js&"
import style0 from "./AlternativePage.vue?vue&type=style&index=0&id=cfdffcc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdffcc4",
  null
  
)

export default component.exports